/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Hero_Fact_3Inputs */

const en_mk_hero_fact_3 = /** @type {(inputs: Mk_Hero_Fact_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Results you can review`)
};

const id_mk_hero_fact_3 = /** @type {(inputs: Mk_Hero_Fact_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasil bisa ditinjau`)
};

/**
* | output |
* | --- |
* | "Results you can review" |
*
* @param {Mk_Hero_Fact_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_hero_fact_3 = /** @type {((inputs?: Mk_Hero_Fact_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Hero_Fact_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_hero_fact_3(inputs)
	return en_mk_hero_fact_3(inputs)
});